var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 704,
    height: 650,
    viewBox: "0 0 704 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.11792,
    width: 703,
    height: 650,
    fill: "#F9F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352.102 395.479C328.664 395.479 305.226 395.479 281.788 395.479C280.643 395.479 279.483 395.479 278.333 395.36C272.465 394.813 270.106 390.86 272.608 385.515C274.78 380.901 277.149 376.405 279.448 371.84C290.306 350.346 301.163 328.856 312.02 307.368C312.355 306.712 312.706 306.056 313.096 305.429C315.83 301.047 320.271 300.43 323.77 304.21C326.238 306.855 328.325 309.826 330.526 312.693C341.712 327.311 352.898 341.935 364.085 356.566C368.97 362.932 375.124 363.278 380.864 357.553C383.711 354.71 386.495 351.794 389.377 348.976C394.573 343.893 400.471 344.199 404.715 350.126C413.233 362.019 421.538 374.071 429.884 386.082C430.536 387.025 431.035 388.064 431.364 389.162C432.173 391.921 431.028 394.141 428.23 394.877C426.476 395.297 424.675 395.491 422.871 395.454C399.294 395.494 375.705 395.502 352.102 395.479Z",
    fill: "#D4D2E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M404.665 277.704C404.659 282.292 403.291 286.774 400.735 290.583C398.178 294.393 394.548 297.357 390.304 299.101C386.061 300.844 381.395 301.288 376.899 300.377C372.403 299.466 368.278 297.24 365.048 293.982C361.819 290.724 359.629 286.58 358.757 282.076C357.885 277.572 358.371 272.91 360.151 268.682C361.932 264.454 364.928 260.85 368.759 258.327C372.591 255.804 377.085 254.475 381.673 254.509C387.782 254.587 393.616 257.062 397.916 261.401C402.217 265.739 404.641 271.595 404.665 277.704Z",
    fill: "#D4D2E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/Image-Placeholder.ab25be99799abd0e5ac956e1309f18e7.svg";
export { ForwardRef as ReactComponent };